<script setup>
import { computed } from 'vue';
import { Primitive } from 'reka-ui';
import { cn } from '@/lib/utils';
import { buttonVariants } from '../button';
import { Loader2 } from 'lucide-vue-next';

const props = defineProps({
    variant: { type: null, required: false },
    size: { type: null, required: false },
    class: { type: null, required: false },
    asChild: { type: Boolean, required: false },
    showContentOnLoading: { type: Boolean, default: true },
    as: { type: null, required: false, default: 'button' },
    isLoading: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    loadingText: { type: String, required: false }
});

// Support both :loading and :is-loading props for backward compatibility
const isLoadingState = computed(() => props.isLoading || props.loading);
</script>

<template>
    <Primitive
        data-slot="button"
        :as="as"
        :as-child="asChild"
        :class="cn(buttonVariants({ variant, size }), props.class)"
        :disabled="isLoadingState">
        <template v-if="isLoadingState">
            <Loader2 class="h-4 w-4 animate-spin" />
            <template v-if="props.loadingText">
                {{ props.loadingText }}
            </template>
            <template v-else-if="props.showContentOnLoading">
                <slot />
            </template>
        </template>
        <template v-else>
            <slot />
        </template>
    </Primitive>
</template>
